<template>
    <Card>
        <template v-slot:icon>
            <i class="fas fa-city"/>
        </template>
        <template v-slot:title>
            {{ __('general.company_details') }}
        </template>
        <template v-slot:description>
            {{ __('actions.manage_thing', {thing: __('general.company_details')}) }}
        </template>

        <FormGroupNew :label="__('general.company_name')"
                      :description="__('company.legal_name_description')"
                      :error="profile.errors.name"
                      required>
            <input type="text" class="form-control" v-model="profile.name">
        </FormGroupNew>

        <FormGroupNew v-if="['DE', 'AT'].includes(profile.country)"
                      :label="__('general.ust_id')"
                      :description="__('company.ust_id_description')"
                      :error="profile.errors.ust_id"
                      required>
            <input type="text" class="form-control" v-model="profile.ust_id">
        </FormGroupNew>

        <div class="row">
            <div class="col-lg-6">
                <FormGroupNew :label="__('general.email')"
                              :description="__('company.email_description')"
                              :error="profile.errors.email"
                              required>
                    <input type="text" class="form-control" v-model="profile.email">
                </FormGroupNew>
            </div>
            <div class="col-lg-6">
                <FormGroupNew :label="__('general.phone')"
                              :description="__('company.phone_description')"
                              :error="profile.errors.phone"
                >
                    <input type="text" class="form-control" v-model="profile.phone">
                </FormGroupNew>
            </div>
        </div>

        <FormGroupNew :label="__('general.website')"
                      :description="__('company.website_description')"
                      :error="profile.errors.website"
        >
            <input type="text" class="form-control" v-model="profile.website">
        </FormGroupNew>

        <div class="row">
            <div class="col-lg-6">
                <FormGroupNew :label="__('general.street') + '1'"
                              :description="__('company.street1_description')"
                              :error="profile.errors.street1"
                              required>
                    <input type="text" class="form-control" v-model="profile.street1">
                </FormGroupNew>
            </div>
            <div class="col-lg-6">
                <FormGroupNew :label="__('general.street') + '2'"
                              :description="__('company.street2_description')"
                              :error="profile.errors.street2"
                >
                    <input type="text" class="form-control" v-model="profile.street2">
                </FormGroupNew>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6">
                <FormGroupNew :label="__('general.postcode')"
                              :description="__('company.postcode_description')"
                              :error="profile.errors.postcode"
                              required>
                    <input type="text" class="form-control" v-model="profile.postcode">
                </FormGroupNew>
            </div>
            <div class="col-lg-6">
                <FormGroupNew :label="__('general.city')"
                              :description="__('company.city_description')"
                              :error="profile.errors.city"
                              required>
                    <input type="text" class="form-control" v-model="profile.city">
                </FormGroupNew>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6">
                <FormGroupNew :label="__('general.state')"
                              :description="__('company.state_description')"
                              :error="profile.errors.state"
                              :required="profile.country === 'US'"
                              no-margin
                >
                    <input type="text" class="form-control" v-model="profile.state">
                </FormGroupNew>
            </div>
            <div class="col-lg-6">
                <FormGroupNew :label="__('general.country')"
                              :description="__('company.country_description')"
                              :error="profile.errors.country"
                              required
                              no-margin
                >
                    <select class="form-control" v-model="profile.country">
                        <option value="" disabled>{{
                                __('actions.select_thing', {thing: __('general.country')})
                            }}
                        </option>
                        <option value="DE">{{ __('countries.with_flag.de') }}</option>
                        <option value="AT">{{ __('countries.with_flag.at') }}</option>
                        <option value="FR">{{ __('countries.with_flag.fr') }}</option>
                        <option value="US">{{ __('countries.with_flag.us') }}</option>
                        <option value="UK">{{ __('countries.with_flag.uk') }}</option>
                    </select>
                </FormGroupNew>
            </div>
        </div>

        <template v-slot:footer>
            <SaveAndEnableButton v-if="profile.isDirty"
                                 @click="saveCompanyProfile"/>
        </template>
    </Card>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import SaveAndEnableButton from "@components/Integrations/SaveAndEnableButton.vue";

export default {
    components: {SaveAndEnableButton, FormGroupNew, Card},

    props: {
        company: Object
    },

    data() {
        return {
            profile: this.$inertia.form(this.company || {
                name: '',
                ust_id: '',
                email: '',
                phone: '',
                website: '',
                street1: '',
                street2: '',
                postcode: '',
                city: '',
                state: '',
                country: ''
            })
        }
    },

    mounted() {
        if (this.profile.country === '') {
            this.guessCountry();
        }
    },

    methods: {
        saveCompanyProfile() {
            this.profile.patch(this.$route('company.update'));
        },

        guessCountry() {
            let userSelectedLanguage = this.$page.props.user.selected_language.toUpperCase();

            switch (userSelectedLanguage) {
                case 'DE':
                    this.profile.country = 'DE';
                    break;

                case 'FR':
                    this.profile.country = 'FR';
                    break;

                case 'EN':
                    this.profile.country = 'US';
                    break;

                default:
                    console.log(`Couldn't guess country for language ${userSelectedLanguage}.`);
            }
        }
    }
}
</script>
